<template>
  <div class="user-cards" id="user-cards-box">
    <div>
      <a :href="$link" class="back-home">Tilbage</a>
      <div class="main-title">
        <h2 v-if="title">{{ title }}</h2>
        <a :href="'#/payment-cards'">Tilføj kort</a>
      </div>
      <!-- <div v-if="$texts.textRegisterCardPage" v-html="$texts.textRegisterCardPage" class="text-register-card-page"></div> -->
      <div class="content">
        <span v-on:click="modalIsOpen" class="plus open-modal">+</span>
        <div class="cards">
          <carousel
            :touchDrag="true"
            :perPage="perPage"
            :loop="true"
            :autoplay="false"
            :navigationEnabled="true"
            :scrollPerPage="true"
            :autoplayTimeout="7000"
            :perPageCustom="[
              [320, 1],
              [768, perPage],
            ]"
          >
            <slide v-for="(card, index) in paymentCards.items" :key="index" data-index="0" data-name="MySlideName" v-if="card.type === 'visa'">
              <div class="card-content">
                <div class="card-info">
                  <!-- <span v-else class="card-name">---</span> - -->
                  <span class="name">{{ card.nameOnCard }}</span>
                  <span class="card-number">**** **** **** {{ card.lastFour }}</span>
                  <span class="card-expiry">{{ card.expiryMonth }} / {{ card.expiryYear }}</span>
                  <span v-if="card.type === 'visa'" class="card-img visa">
                    <span class="visa"></span>
                  </span>
                  <div class="show-on-dashboard">
                    <span class="card-name">{{ card.type }}</span>
                    <span class="card-number">**** **** **** {{ card.lastFour }}</span>
                    <span class="card-expiry">{{ card.expiryMonth }} / {{ card.expiryYear }}</span>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <div class="plus-mobile">
          <span class="open-modal"><a :href="$settings.paymentcard_redirect_url" style="color: #fff" target="_blank">Tilmeld flere kort</a></span>
        </div>
      </div>
    </div>

    <!-- Modal / Register new card -->
    <!-- Register new card -->
    <!-- End modal -->
  </div>
</template>

<script>
import PaymentCard from 'cashback-api-js/Resources/PaymentCard'
import {PureModal} from 'vue-pure-modal'
import {Carousel, Slide} from 'vue-carousel'
import 'vue-pure-modal/dist/puremodal.css'

export default {
  name: 'PaymentCards',

  props: {
    title: {
      type: String,
      default: 'Mine kort',
    },
    perPage: {
      type: Number,
      default: 2,
    },
  },

  components: {
    // 'payment-cards-register': PaymentCardsRegister,
    'pure-modal': PureModal,
    'carousel': Carousel,
    'slide': Slide,
  },

  data() {
    return {
      paymentCards: {
        total: 0,
        items: [],
      },
      errorMessage: null,
      // showRegisterCard: false,
      // showSuccessfullyRegisterCard: false,
      newCard: new PaymentCard(),
      loading: false,
      validation: {},
      remove: null,
      // contetnSuccessRegisterCard: this.$texts.textSuccessfullyRegisterCard,
      // showSuccessRegisterCard: false,
    }
  },

  mounted() {
    this.getPaymentCards()
  },

  methods: {
    getPaymentCards() {
      this.$cashback.paymentCards().then((cards) => {
        this.paymentCards = cards
        this.$emit('loaded')
      })
    },

    modalIsOpen() {
      this.showSuccessRegisterCard = false
      this.showRegisterCard = true
    },
    toggleRemoveBtn(index) {
      this.remove = this.remove != null ? (this.remove = null) : (this.remove = index)
    },

    deleteItem(parmentCardId, index) {
      this.$cashback
        .paymentCardDelete(parmentCardId)
        .then((parmentCardId) => {
          this.paymentCards.total -= 1
          this.paymentCards.items.splice(index, 1)
          return
        })
        .catch((error) => {})
    },

    modalOpen() {
      this.$refs.cardNumInput.focus()
    },

    modalClose() {
      this.loading = false
      this.successMessage = null
      this.errorMessage = null
      if (this.contetnSuccessRegisterCard != undefined && this.contetnSuccessRegisterCard != '') {
        this.showSuccessRegisterCard = true
      } else {
        this.showRegisterCard = false
        this.resetNewCardForm()
      }
      this.getPaymentCards()
    },

    resetNewCardForm() {
      this.newCard = new PaymentCard()
    },
  },
}
</script>
